import variables from '@ingka/variables/colours-css';

export default {
  background: {
    alternative: `${variables.colourNeutral3}`,
    accent: `${variables.colourStaticIkeaBrandBlue}`,
    default: `${variables.colourNeutral1}`,
  },
  icon: {
    default: `${variables.colourTextAndIcon1}`,
  },
  neutral: {
    white: `${variables.colourNeutral1}`,
    grey200: `${variables.colourNeutral3}`,
    grey300: `${variables.colourNeutral4}`,
    grey500: `${variables.colourNeutral5}`,
  },
  text: {
    default: `${variables.colourTextAndIcon2}`,
  },
  semantic: {
    positive: `${variables.colourSemanticPositive}`,
  },
  ikeaFamily: {
    ikeaBlue: `${variables.colourStaticIkeaBrandBlue}`,
  },
};
